export const getBetBuilderURL = (sportcastId, oddsFormat, language, skinConfig) => {
    const oddType = skinConfig.oddsMap[oddsFormat] || 'DecimalPrice';
    const cultureType = skinConfig.languageMap[language] || 'en-GB';

    const queryParams = new URLSearchParams();

    queryParams.append('odds', oddType);
    queryParams.append('culture', cultureType);
    queryParams.append('fixtureId', sportcastId);
    queryParams.append('password', skinConfig.password);
    queryParams.append('key', skinConfig.licenseKey);
    queryParams.append('brand', skinConfig.brand)


    return `${skinConfig.url}?${queryParams.toString()}`;
}

const _handleUpdateAddToBetslip = (data, skinConfig, oddsFormat) => {
    const oddType = skinConfig.oddsMap[oddsFormat];

    return {
        betslipUid: data.betslipUid,
        selections: data.betBuilderData.Selection,
        price: data.betBuilderData.PriceDetails[skinConfig.oddsMap.decimal],
        formattedPrice: data.betBuilderData.PriceDetails[oddType],
    };
};

export const handleBetBuilderUpdateData = (data, skinConfig, oddsFormat) => {
    if (!data.command) return data;

    const commandMap = {
        addToBetslip: _handleUpdateAddToBetslip(data, skinConfig, oddsFormat),
    };

    return commandMap[data.command] || data;
}